<template>
  <c-row>
    <c-col col="8">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Penggunaan</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <c-row>
            <c-col col="4">
              <div class="form-group form-row">
                <label class="col-sm-4 col-form-label">Jenis</label>
                <div class="col-md-8">
                  <select2
                    :items="kasFlow"
                    placeholder="Pilih Jenis"
                    label="Type"
                    v-model="pettyCash.type"
                    v-bind:class="{ 'has-error': errors.type }"
                  />
                </div>
              </div>
              <div class="form-group form-row">
                <label class="col-sm-4 col-form-label">Tanggal</label>
                <div class="col-md-8">
                  <datetime
                    v-model="pettyCash.created_at"
                    class="date-control"
                    v-bind:class="{ 'has-error': errors.created_at }"
                  />
                </div>
              </div>
              <div class="form-group form-row">
                <label class="col-sm-4 col-form-label">Nilai</label>
                <div class="col-md-8">
                  <input
                    type="text"
                    class="form-control right"
                    v-model="pettyCash.amount"
                    v-bind:class="{ 'has-error': errors.amount }"
                  />
                </div>
              </div>
            </c-col>
            <c-col col="8">
              <div class="form-group form-row">
                <label class="col-sm-3 col-form-label">COA</label>
                <div class="col-md-9">
                  <select-x
                    :url="`/api/v1/coa`"
                    placeholder="Pilih COA"
                    v-model="pettyCash.coa"
                    v-bind:class="{ 'has-error': errors.type }"
                  />
                </div>
              </div>
              <div class="form-group form-row">
                <label class="col-sm-3 col-form-label">Penjelasan</label>
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="pettyCash.description"
                    v-bind:class="{ 'has-error': errors.description }"
                  />
                </div>
              </div>
              <div class="form-group form-row">
                <label class="col-sm-3 col-form-label">Keterangan</label>
                <div class="col-md-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="pettyCash.notes"
                    v-bind:class="{ 'has-error': errors.notes }"
                  />
                </div>
              </div>
            </c-col>
          </c-row>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-success" @click="addTransaction">
            <i class="cil-save"></i> Save
          </button>
        </c-card-footer>
      </c-card>
      <petty-cash />
    </c-col>
    <c-col col="4">
      <c-card>
        <c-card-body>
          <loader v-show="loading" />
          <div class="form-group form-row sm-padding">
            <label class="col-form-label col-sm-5">Saldo Transaksi</label>
            <div class="col-md-7">
              <label class="right bold form-control">{{
                historyBalance | thousandSeparator
              }}</label>
            </div>
          </div>
          <div class="form-group form-row sm-padding">
            <label class="col-form-label col-sm-5">Saldo Stock</label>
            <div class="col-md-7">
              <label class="right bold form-control">{{
                total | thousandSeparator
              }}</label>
            </div>
          </div>
          <table class="table table-bordered table-striped table-sm-padding">
            <thead>
              <tr>
                <th width="80">Pecahan</th>
                <th width="50">Qty</th>
                <th>Sub Total</th>
                <th width="75"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in data" :key="k">
                <td class="right">{{ d.kind | thousandSeparator }}</td>
                <td class="right">{{ d.qty | thousandSeparator }}</td>
                <td class="right">
                  {{ (d.kind * d.qty) | thousandSeparator }}
                </td>
                <td align="center">
                  <button class="btn btn-warning btn-action" @click="minus(d)">
                    <i class="cil-minus"></i>
                  </button>
                  <button class="btn btn-success btn-action" @click="plus(d)">
                    <i class="cil-plus"></i>
                  </button>
                </td>
              </tr>
              <tr class="tr-input" v-show="needApprove">
                <td colspan="3">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Tambahkan Keterangan"
                    v-model="notes"
                    v-bind:class="{ 'has-error': this.notes == '' }"
                  />
                </td>
                <td colspan="1" align="right">
                  <button class="btn btn-success right" @click="addStock">
                    <i class="cil-check"></i>
                  </button>
                </td>
              </tr>
              <tr class="tr-input" v-show="addKind">
                <td>
                  <input
                    type="text"
                    class="form-control right"
                    v-model="stock.kind"
                    @keyup="calculate"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control right"
                    v-model="stock.qty"
                    @keyup="calculate"
                  />
                </td>
                <td>
                  <span class="form-control right">{{
                    stock.sub_total | thousandSeparator
                  }}</span>
                </td>
                <td>
                  <button class="btn btn-success" @click="save">
                    <i class="cil-plus"></i>Add
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import Select2 from "../../components/Select2";
import SelectX from "../../components/SelectX";
import { HTTPAUTH } from "../../lib/httplib";
import Loader from '../../components/Loader.vue';
import PettyCash from '../logbook/components/PettyCash.vue';
export default {
  components: {
    Select2,
    Loader,
    PettyCash,
    SelectX,
  },
  data () {
    return {
      data: [],
      stock: {
        kind: 0,
        qty: 1,
        sub_total: 0
      },
      total: 0,
      loading: true,
      pettyCash: {
        created_at: ""
      },
      needApprove: false,
      addKind: false,
      notes: "",
      historyBalance: 0,
      kasFlow: ["debit", "kredit"],
      errors: [],
      historyLoader: false
    };
  },
  created () {
    this.get();
    this.init();
  },
  methods: {
    init () {
      this.pettyCash = {
        type: "kredit",
        created_at: moment().format()
      }
    },
    get () {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/petty-cash`)
        .then(res => {
          this.data = res.data.data;
          this.stock = {
            kind: 0,
            qty: 1,
            sub_total: 0
          };
          this.calculate();
          this.disableLoading();
          this.getBalance();
        })
        .catch(() => {
          this.disableLoading();
        });
    },
    getBalance () {
      HTTPAUTH.get(`/api/v1/petty-cash-transaction/balance`)
        .then(res => {
          this.historyBalance = res.data.data;
        })
        .catch(() => {
          this.historyBalance = 0;
        });
    },
    disableLoading () {
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    save () {
      HTTPAUTH.post("/api/v1/petty-cash", this.stock)
        .then(() => {
          this.get();
          this.init();
          this.$store.dispatch('pettycash_cash_history', { page: 1, q: '' });
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    addStock () {
      if (!this.notes || this.notes == "") {
        this.$toasted.error("Tambahkan keterangan").goAway(2000);
        return;
      }
      HTTPAUTH.put("/api/v1/petty-cash-update", {
        items: this.data,
        notes: this.notes
      })
        .then(() => {
          this.get();
          this.needApprove = false;
          this.notes = "";
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    update (id, data) {
      HTTPAUTH.put("/api/v1/petty-cash/" + id, data)
        .then(() => {
          this.get();
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    plus (data) {
      data.qty += 1;
      if (data.qty_add) {
        data.qty_add += 1;
      } else {
        data.qty_add = 1;
      }
      this.checkNeedApprove(data);
      data.sub_total = data.kind * data.qty;
      this.calculate();
      // this.update(data.id, data);
    },
    checkNeedApprove (data) {
      if (data.qty_add && data.qty_add > 0) {
        this.needApprove = true;
      } else {
        this.needApprove = false;
      }
    },
    minus (data) {
      data.sub_total = data.kind * data.qty;
      data.qty_add -= 1;
      if (!data.qty_add || data.qty_add <= 0) {
        data.qty -= 1;
        this.update(data.id, data);
      }
      this.checkNeedApprove(data);
    },
    calculateTotal () {
      this.total = 0;
      for (var i in this.data) {
        this.total += this.data[i].qty * this.data[i].kind;
      }
    },
    calculate () {
      this.stock.sub_total = this.stock.kind * this.stock.qty;
      this.calculateTotal();
    },
    addTransaction () {
      if (this.pettyCash.coa) {
        this.pettyCash.coa_id = this.pettyCash.coa.id;
      }
      HTTPAUTH.post("/api/v1/petty-cash-transaction", this.pettyCash).then(
        () => {
          this.get();
          this.init();
          this.$store.dispatch('pettycash_cash_history', { page: 1, q: '' });
        }
      ).catch(eres => {
        if (eres.response.data.message) {
          this.$toasted.error(eres.response.data.message).goAway();
          this.errors = eres.response.data.errors;
          return;
        }
        this.$toasted.error(eres.response.data.user_message).goAway();
      });
    }
  }
};
</script>